import { render, staticRenderFns } from "./setLeader.vue?vue&type=template&id=6769b09c&scoped=true"
import script from "./setLeader.vue?vue&type=script&lang=js"
export * from "./setLeader.vue?vue&type=script&lang=js"
import style0 from "./setLeader.vue?vue&type=style&index=0&id=6769b09c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6769b09c",
  null
  
)

export default component.exports